var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Maps = YouLi.Trip.Maps ? YouLi.Trip.Maps : {};

(function (YouLi) {
    (function (Trip) {
        (function (Maps) {

            YouLi.Trip.Maps.MapObject = null;
            YouLi.Trip.Maps.PreviousSelectedMarker = undefined;
            YouLi.Trip.Maps.ItineraryMarker = "/content/img/map-marker-itinerary-icon.svg";
            YouLi.Trip.Maps.ItineraryMarkerSelected = "/content/img/map-marker-itinerary-selected-icon.svg";
            YouLi.Trip.Maps.LocationMarker = "/content/img/map-marker-icon.svg";

            var allMarkerBounds;
            var mapLoaded = false;

            YouLi.Trip.Maps.SetupLocationMap = function () {
                allMarkerBounds = new google.maps.LatLngBounds();

                Geocoder = new google.maps.Geocoder();

                var StyledMapType = new google.maps.StyledMapType(YouLi.Maps.Style.StyledMapJSON);

                YouLi.Trip.Maps.MapObject = new google.maps.Map(document.getElementById('TripLocationMap'), {
                    zoom: 10,
                    scrollwheel: false,
                    mapTypeControl: false,
                    mapTypeControlOptions: {
                        mapTypeIds: ['styled_map']
                    }
                });

                google.maps.event.addListenerOnce(YouLi.Trip.Maps.MapObject, 'idle', function () {
                    var address = $("#PrimaryLocationValue").text();
                    var primaryLatitude = $("#PrimaryLocationLatitude").val();
                    var primaryLongitude = $("#PrimaryLocationLongitude").val();

                    if (address && primaryLatitude && primaryLongitude) {
                        var primaryLocationLatLng = new google.maps.LatLng(primaryLatitude, primaryLongitude);

                        YouLi.Trip.Maps.AddLocationMarker(primaryLocationLatLng, address);
                    }
                    else {
                        // nb: not geocoding the primary location at all at this stage
                        //YouLi.Trip.Maps.CodeAddress(address);
                    }

                    mapLoaded = true;
                });

                //Associate the styled map with the MapTypeId and set it to display.
                YouLi.Trip.Maps.MapObject.mapTypes.set('styled_map', StyledMapType);
                YouLi.Trip.Maps.MapObject.setMapTypeId('styled_map');

            }

            YouLi.Trip.Maps.InitialiseItinerary = function () {
                if (!mapLoaded) {
                    window.setTimeout(function () {
                        YouLi.Trip.Maps.InitialiseItinerary();
                    }, 250)
                }
                else {
                    for (var i = 0; i < YouLi.Trip.Itinerary.ScheduleItemsOnMap.length; i++) {
                        var currentItem = YouLi.Trip.Itinerary.ScheduleItemsOnMap[i];
                        // Map items that have a location AND that are either a highlight item or have a start date.
                        // Items that have no start date and are NOT highlights do not currently get shown on the itinerary
                        if (!currentItem.LocationHideOnMap && currentItem.Location ) {

                            if (currentItem.LocationLatitude && currentItem.LocationLongitude) {

                                var locationLatLng = new google.maps.LatLng(currentItem.LocationLatitude, currentItem.LocationLongitude);

                                YouLi.Trip.Maps.AddLocationMarker(locationLatLng, currentItem.Location, currentItem)
                            }
                            else {
                                YouLi.Trip.Maps.CodeAddress(currentItem.Location, currentItem);
                            }
                        }
                    }
                }
            }

            YouLi.Trip.Maps.CodeAddress = function (address, itineraryItem) {
                Geocoder.geocode({ 'address': address }, function (results, status) {
                    if (status == 'OK') {

                        YouLi.Trip.Maps.AddLocationMarker(results[0].geometry.location, address, itineraryItem)

                    } else {
                        console.log('Geocode was not successful for the following reason: ' + status);
                    }
                });
            };

            YouLi.Trip.Maps.AddLocationMarker = function (geometryLocation, address, itineraryItem) {

                markerIcon = itineraryItem !== undefined ? YouLi.Trip.Maps.ItineraryMarker : YouLi.Trip.Maps.LocationMarker;

                var iwContents = "";

                if (itineraryItem !== undefined) {

                    if (window.innerWidth >= 992) {

                        var imageURL = itineraryItem.ImageURL;
                        if (!imageURL.startsWith("http")) {
                            imageURL = "https://ylt-images.imgix.net/" + imageURL;
                        }
                        var itemStartDate = itineraryItem.StartDateTime !== null && itineraryItem.StartDateTime.length > 0 ? moment(itineraryItem.StartDateTime).format("YYYY-MM-DD") : "highlights";

                        iwContents = "<div class='iw-container'>" +
                            (imageURL.length == 0 ? "" : "<div class='iw-title'><img src='" + imageURL + "' /></div>") +
                            "<div class='text'><h2 onclick=\"YouLi.Trip.Maps.GoToItem('" + itemStartDate + "', '" + itineraryItem.ScheduleItemId + "');\">" + itineraryItem.Name + "</h2>" +
                            "<p><strong>Location: </strong>" + itineraryItem.Location + "<br />" +
                            (itineraryItem.DateLabel.length == 0 ? "" : "<strong>Date: </strong>" + itineraryItem.DateLabel + "</p>") +
                            "</div>" +
                            "<div class='iw-bottom-gradient'></div></div > ";
                    }
                    else {
                        iwContents = "<div class='iw-container'>" +
                            "<div class='text'><h3 onclick=\"YouLi.Trip.Maps.GoToItem('" + itemStartDate + "', '" + itineraryItem.ScheduleItemId + "');\">" + itineraryItem.Name + "</h3>" +
                            "<p><strong>Location: </strong>" + itineraryItem.Location + "<br />" +
                            (itineraryItem.DateLabel.length == 0 ? "" : "<strong>Date: </strong>" + itineraryItem.DateLabel + "</p>") +
                            "</div>" +
                            "<div class='iw-bottom-gradient'></div></div > ";
                    }
                }
                else {
                    // Trip location:
                    iwContents = "<div class='text'><h2><a href=\"https://www.google.com/maps/dir/?api=1&amp;destination=" + address + "\" target=\"_blank\">" + $("#PrimaryLocationValue").text() + "</a></h2></div>";
                }

                var marker = new google.maps.Marker({
                    map: YouLi.Trip.Maps.MapObject,
                    position: geometryLocation,
                    icon: markerIcon,
                    isItinerary: itineraryItem !== undefined,
                    infowindow: new google.maps.InfoWindow({ content: iwContents, maxWidth: 200, disableAutoPan: true })     /*pixelOffset: new google.maps.Size(0, 0)*/
                });

                google.maps.event.addListener(marker.infowindow, 'domready', function () {
                    // Handy reference: http://en.marnoto.com/2014/09/5-formas-de-personalizar-infowindow.html
                    var iwOuter = $('.gm-style-iw');

                    var iwBackground = iwOuter.prev();
                    iwBackground.children(':nth-child(2)').css({ 'display': 'none' }); // Remove the background shadow DIV
                    iwBackground.children(':nth-child(4)').css({ 'display': 'none' }); // Remove the white background DIV
                    //iwOuter.parent().parent().css({ left: '115px' });

                    // Hide the arrow
                    iwBackground.children(':nth-child(1)').css({ 'display': 'none' });
                    iwBackground.children(':nth-child(3)').css({ 'display': 'none' });

                    var iwCloseBtn = iwOuter.next();
                    iwCloseBtn.css({ 'display': 'none' });

                    /*
                    // Apply the desired effect to the close button
                    iwCloseBtn.css({
                        opacity: '1', // by default the close button has an opacity of 0.7
                        right: '78px',
                        top: '23px'
                    });

                    // The API automatically applies 0.7 opacity to the button after the mouseout event.
                    // This function reverses this event to the desired value.
                    iwCloseBtn.mouseout(function () {
                        $(this).css({ opacity: '1' });
                    });
                    */
                });

                marker.addListener('click', function () {
                    YouLi.Trip.Maps.ClosePrevioulsyOpenedInfoWindow();

                    if (this.isItinerary) {
                        this.setIcon(YouLi.Trip.Maps.ItineraryMarkerSelected);
                    }
                    YouLi.Trip.Maps.PreviousSelectedMarker = this;
                    this.infowindow.open(YouLi.Trip.Maps.MapObject, this);
                });

                google.maps.event.addListener(YouLi.Trip.Maps.MapObject, "click", function (event) {
                    YouLi.Trip.Maps.ClosePrevioulsyOpenedInfoWindow();
                });

                allMarkerBounds.extend(new google.maps.LatLng(geometryLocation.lat(), geometryLocation.lng()));
                YouLi.Trip.Maps.MapObject.fitBounds(allMarkerBounds);

                // Nb: only change zoom to encapsulate all markers if there are any itinerary items
                if (YouLi.Trip.Itinerary.ScheduleItemsOnMap == null
                    || YouLi.Trip.Itinerary.ScheduleItemsOnMap.filter(function (item) { return item.Location != null && item.Location != "" && !item.LocationHideOnMap }).length == 0) {
                    YouLi.Trip.Maps.MapObject.setZoom(10);
                } else {
                    YouLi.Trip.Maps.MapObject.setZoom(YouLi.Trip.Maps.MapObject.getZoom() - 2);
                }
            };

            YouLi.Trip.Maps.ClosePrevioulsyOpenedInfoWindow = function () {
                if (YouLi.Trip.Maps.PreviousSelectedMarker) {
                    if (YouLi.Trip.Maps.PreviousSelectedMarker.isItinerary) {
                        YouLi.Trip.Maps.PreviousSelectedMarker.setIcon(YouLi.Trip.Maps.ItineraryMarker);
                    }
                    YouLi.Trip.Maps.PreviousSelectedMarker.infowindow.close();
                }
            };

            YouLi.Trip.Maps.GoToItem = function (itineraryItemDate, itineraryItemId) {
                YouLi.Trip.GoToSection("itinerary", null, true);
                YouLi.Trip.Itinerary.GoToDate(itineraryItemDate);
            };

        }(YouLi.Trip.Maps ? YouLi.Trip.Maps : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));